import { getEnumValueLabel, TranslateLike } from './helper';

const ORDER_STATUS_KEY_MAP = {
  ALL: 'domain.order.status.all',
  WAITING_PAY: 'domain.order.status.unpaid',
  WAITING_DELIVERY: 'domain.order.status.toShip',
  WAITING_SIGN: 'domain.order.status.inTransit',
  TRADE_SUCCESS: 'domain.order.status.completed',
  CANCEL: 'domain.order.status.cancelled',
  REFUND: 'domain.order.status.returnRefund',
  IN_CANCELING: 'domain.order.status.canceling',
  MULTIPLE_STATUS: 'domain.order.status.mixedStatus',
  UNKNOWN_ORDER_STATUS: 'domain.order.status.unknown',
} as const;

const ORDER_ERP_STATUS_KEY_MAP = {
  WAIT_PAYMENT: 'domain.order.erpStatus.unpaid',
  WaitPay: 'domain.order.erpStatus.unpaid',
  WAIT_AUDIT: 'domain.order.erpStatus.unreviewed',
  WaitConfirm: 'domain.order.erpStatus.unreviewed',
  WAIT_SHIP: 'domain.order.erpStatus.toShip',
  WaitOuterSent: 'domain.order.erpStatus.toShip',
  SHIPPING: 'domain.order.erpStatus.inTransit',
  Delivering: 'domain.order.erpStatus.inTransit',
  SHIP_FAILURE: 'domain.order.erpStatus.shipFailure',
  PARTIALLY_SHIPPED: 'domain.order.erpStatus.partiallyShipped',
  SHIPPED: 'domain.order.erpStatus.shipped',
  Sent: 'domain.order.erpStatus.shipped',
  CLOSED: 'domain.order.erpStatus.closed',
  Merged: 'domain.order.erpStatus.merged',
  Question: 'domain.order.erpStatus.exception',
  Split: 'domain.order.erpStatus.split',
  WaitFConfirm: 'domain.order.erpStatus.financialReviewPending',
  Cancelled: 'domain.order.erpStatus.cancelled',
} as const;

const RETURN_REFUND_LOGISTICS_STATUS_KEY_MAP = {
  LE_CHAT_NOT_START: 'order.returnRefund.logistics.status.notShipped',
  LE_CHAT_PACKAGE_LOST: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_PACKAGE_RETURN_SUCCESS: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_PACKAGE_SCRAPPED: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_RETURN_FAIL_SCRAPPED: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_RETURN_FAIL_WAIT_SELLER_PICK: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_SEND_FAIL: 'order.returnRefund.logistics.status.deliveryFailed',
  LE_CHAT_SIGNED: 'order.returnRefund.logistics.status.received',
  LE_CHAT_TRADE_CLOSED: 'order.returnRefund.logistics.status.orderClosed',
  LE_CHAT_UNKNOWN_TRACE: 'order.returnRefund.logistics.status.unknown',
  LE_CHAT_WAITING_COLLECT: 'order.returnRefund.logistics.status.deliveryNotStarted',
  LE_CHAT_WAITING_SEND: 'order.returnRefund.logistics.status.outForDelivery',
  LE_CHAT_WAITING_SIGN: 'order.returnRefund.logistics.status.awaitingReceipt',
} as const;

const LAZADA_INCOME_KEY_MAP = {
  Commission: 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.commission',
  'Customer Return Delivery Fee':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.customerReturnDeliveryFee',
  'Domestic Shipping fees':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.domesticShippingFees',
  'FBL Handling Fee': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.fblHandlingFee',
  'FBL Item Handling Fee':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.fblItemHandlingFee',
  'Free Shipping Max Fee':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.freeShippingMaxFee',
  'Freeship Max Fee Discount Rebate':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.freeshipMaxFeeDiscountRebate',
  'GST on Imported Low-Value Goods':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.importedLowValueGoodsGst',
  'Grand Total': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.grandTotal',
  'Import Duties and Tax (Charged by 3PL)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.importDutiesTaxChargedBy3pl',
  'Import Duties and Tax (Paid by Customer)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.importDutiesTaxPaidByCustomer',
  'International Shipping fees':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.internationalShippingFees',
  'Item Price Credit': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.itemPriceCredit',
  'LCP Fee': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lcpFee',
  'LazFlash Extra/Everyday Below $9.99 Subsidy':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazFlashExtraSubsidy',
  'Lazada Bonus': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaBonus',
  'Lazada Bonus - LZD co-fund':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaBonusLzdCoFund',
  'Lazada Bonus - LZD co-fund - Reversal':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaBonusLzdCoFundReversal',
  'Lazada Bonus - Reversal':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaBonusReversal',
  'Lazcoin discount': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazcoinDiscount',
  'Lazpick/LazTop/Super commission - Reversal':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazpickSuperCommissionReversal',
  'Lazpick/Laztop/Super Seller Commission':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazpickSuperSellerCommission',
  'Payment Fee': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.paymentFee',
  'Promotional Charges Flexi-Combo':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.promotionalChargesFlexiCombo',
  'Promotional Charges Vouchers':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.promotionalChargesVouchers',
  'Reversal Commission': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalCommission',
  'Reversal Item Price': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalItemPrice',
  'Reversal LCP Fee': 'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalLcpFee',
  'Reversal Lazcoin discount':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalLazcoinDiscount',
  'Reversal Promotional Charges Flexi-Combo':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalPromotionalChargesFlexiCombo',
  'Reversal Promotional Charges Vouchers':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalPromotionalChargesVouchers',
  'Reversal of Free Shipping Max Fee':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.reversalFreeShippingMaxFee',
  'Shipping Fee (Charged By 3P)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.shippingFeeChargedBy3p',
  'Shipping Fee (Paid By Customer)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.shippingFeePaidByCustomer',
  'Shipping Fee Paid by Seller':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.shippingFeePaidBySeller',
  'Shipping Fee Refund to Customer':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.shippingFeeRefundToCustomer',
  'Shipping Fee Subsidy (By Seller)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.shippingFeeSubsidyBySeller',
  'Shipping Fee Voucher (by Lazada)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaShippingFeeVoucher',
  'Shipping Fee Voucher Refund to Laz':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.lazadaShippingFeeVoucherRefund',
  'Sponsored Affiliates':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.sponsoredAffiliates',
  'XB FBL WH Item Handling fee (Agent)':
    'scene.chatWorkspace.orderTab.orderDetail.lazadaIncome.xbFblWhItemHandlingFeeAgent',
} as const;

export const getOrderStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ORDER_STATUS_KEY_MAP);

export const getOrderErpStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ORDER_ERP_STATUS_KEY_MAP);

export const getReturnRefundLogisticsStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, RETURN_REFUND_LOGISTICS_STATUS_KEY_MAP);

export const getLazadaIncomeLabel = (t: TranslateLike, name?: string | null) =>
  getEnumValueLabel(t, name, LAZADA_INCOME_KEY_MAP);

const LOGISTICS_SHIPMENT_STATUS_KEY_MAP = {
  LE_CHAT_NOT_START: 'domain.order.logistics.shipmentStatus.notShipped',
  LE_CHAT_WAITING_COLLECT: 'domain.order.logistics.shipmentStatus.deliveryNotStarted',
  LE_CHAT_WAITING_SEND: 'domain.order.logistics.shipmentStatus.outForDelivery',
  LE_CHAT_WAITING_SIGN: 'domain.order.logistics.shipmentStatus.awaitingReceipt',
  LE_CHAT_SIGNED: 'domain.order.logistics.shipmentStatus.delivered',
  LE_CHAT_PACKAGE_LOST: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_PACKAGE_RETURN_SUCCESS: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_PACKAGE_SCRAPPED: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_RETURN_FAIL_SCRAPPED: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_RETURN_FAIL_WAIT_SELLER_PICK: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_SEND_FAIL: 'domain.order.logistics.shipmentStatus.deliveryFailed',
  LE_CHAT_TRADE_CLOSED: 'domain.order.logistics.shipmentStatus.orderClosed',
  LE_CHAT_UNKNOWN_TRACE: 'domain.order.logistics.shipmentStatus.unknown',
} as const;

const ERP_SHIPMENT_STATUS_KEY_MAP = {
  CREATED: 'domain.order.logistics.erpShipmentStatus.pendingCollection',
  IN_TRANSIT: 'domain.order.logistics.erpShipmentStatus.inTransit',
  OUT_FOR_DELIVERY: 'domain.order.logistics.erpShipmentStatus.outForDelivery',
  DELIVERED: 'domain.order.logistics.erpShipmentStatus.delivered',
  NOT_FOUND: 'domain.order.logistics.erpShipmentStatus.notFound',
  UNDELIVERABLE: 'domain.order.logistics.erpShipmentStatus.exception',
} as const;

const ERP_ORDER_STATUS_KEY_MAP: Record<string, string> = {
  LE_CHAT_UNPAID: 'domain.order.status.unpaid',
  LE_CHAT_READY_TO_SHIP: 'domain.order.status.toShip',
  LE_CHAT_IN_CANCEL: 'domain.order.status.canceling',
  LE_CHAT_CANCELED: 'domain.order.status.cancelled',
  LE_CHAT_COMPLETED: 'domain.order.status.completed',
  LE_CHAT_NO_ORDER: 'domain.order.status.noOrder',
  LE_CHAT_UNKNOWN_TRADE: 'domain.order.status.unknown',
  LE_CHAT_WAIT_CONFIRM: 'domain.order.status.awaitingReceipt',
  LE_CHAT_LOST: 'domain.order.status.parcelLost',
  LE_CHAT_DAMAGED: 'domain.order.status.parcelDamaged',
  LE_CHAT_TO_RETURN: 'domain.order.status.returnPending',
  LE_CHAT_RETURNED: 'domain.order.status.returned',
  LE_CHAT_IN_RETURN: 'domain.order.status.returning',
  LE_CHAT_RETURN_SUCCESS: 'domain.order.status.returnSuccess',
  LE_CHAT_RETURN_FAILED: 'domain.order.status.returnFailed',
  LE_CHAT_RETURN_SCRAPPED: 'domain.order.status.returnParcelDamaged',
};

export const getLogisticsShipmentStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, LOGISTICS_SHIPMENT_STATUS_KEY_MAP);

export const getErpShipmentStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ERP_SHIPMENT_STATUS_KEY_MAP);

export const getErpOrderStatusLabel = (t: TranslateLike, status?: string | null) =>
  getEnumValueLabel(t, status, ERP_ORDER_STATUS_KEY_MAP);
